<template>
    <div>
        <el-table
                :data="tableData"
                border
                :max-height="tableHeight"
                :header-cell-class-name="tableHeaderCls"
                v-loading="dashboardTableLoading || loading"
                show-summary
                :summary-method="getSummaries"
                size="mini"
                style="width: 100%">
            <el-table-column
                    prop="target"
                    label=""
                    align="left"
                    show-overflow-tooltip
                    width="200">
            </el-table-column>
            <el-table-column
                    prop="initiated"
                    :label="$t('ECHANGE_STATUS._1')"
                    align="center"
                    min-width="125"
            >
            </el-table-column>
            <el-table-column
                    prop="submittedToGroup"
                    :label="$t('ECHANGE_STATUS._2')"
                    align="center"
                    min-width="125"
            >
            </el-table-column>
            <el-table-column
                    prop="revisionRequired"
                    :label="$t('ECHANGE_STATUS._3')"
                    align="center"
                    min-width="125"
            >
            </el-table-column>
            <el-table-column
                    prop="approvedByGroupTeam"
                    :label="$t('ECHANGE_STATUS._4')"
                    align="center"
                    min-width="125"
            >
            </el-table-column>

            <el-table-column
                    prop="total"
                    :label="$t('DASHBOARD_TOTAL')"
                    align="center"
                    min-width="100"
            >
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        name: "summary-table",
        data(){
            return {
                summary: [], // 记录最后一行数据，供百分比计算
                loading: false,
                tableHeight: 0
            }
        },
        props: {
            tableData: Array,
            unitRadio: Number,
            dashboardTableLoading: Boolean
        },
        mounted() {
            this.$nextTick(() => {
                this.tableHeight = document.documentElement.clientHeight / 2.1
            })
        },
        methods: {
            tableHeaderCls({row, column, rowIndex, columnIndex}){
                switch(columnIndex){
                    case 1: return 'yellow';                    case 2: return 'darkRed';                    case 3: return 'blue';                    case 4: return 'red';                    case 5: return 'green';                    default: return ''
                }
            },
            getSummaries(param){
                this.loading = true
                const { columns, data } = param;
                const sums = [];
                if(this.unitRadio == 1){
                    columns.forEach((column, index) => {
                        if (index === 0) {
                            sums[index] = this.$t('DASHBOARD_TOTAL');
                            return;
                        }
                        const values = data.map(item => item[column.property]);
                        let itemCount = 0
                        values.forEach(item => {
                            itemCount += item
                        })
                        sums[index] = itemCount
                        this.summary[index] = itemCount
                    })
                } else {
                    sums[0] = this.$t('DASHBOARD_TOTAL');
                    let len = this.summary.length
                   for(let i = 1;i < len-1 ; i++){
                       sums[i] = this.summary[len-1]== 0 ? '0%' : Math.round(this.summary[i] * 100 / this.summary[len-1]) + '%'
                   }
                   sums[len-1] = this.summary[len-1]
                }
                this.loading = false
                return sums;
            }
        }
    }
</script>

<style scoped>
    ::v-deep .yellow{
        background-color: #989898 !important;
        color:#ffffff !important;;
    }
    ::v-deep .darkRed{
        background-color: #1e49e2 !important;
        color: #ffffff !important;;
    }
    ::v-deep .red{
        background-color: #269924 !important;
        color: #ffffff !important;;
    }
    ::v-deep .blue{
        background-color: #fd349c !important;
        color: #ffffff !important;;
    }
    ::v-deep .green{
        /* background-color: #00c0ae !important; */
        /* color: #ffffff !important;; */
    }
</style>